export default __webpack_public_path__ + "static/media/tomy.1319858b.png";